import {
  FETCH_CHALLENGES,
  FETCH_LEADERBOARD,
  SHOWPOPUP_MODAL,
  CERTIFICATE_MODAL,
  USER_GAME_POINTS,
  FETCH_TEAM_LEADERBOARD
} from '../actions';

export const gamificationChallenges = (state = {}, action) => {
  if (action.type === FETCH_CHALLENGES) return action.payload;
  return state;
};

export const gamificationLeaderboard = (state = [], action) => {
  if (action.type === FETCH_LEADERBOARD) return action.payload;
  return state;
};

export const gamificationShowPopup = (state = [], action) => {
  if (action.type === SHOWPOPUP_MODAL) return action.payload;
  return state;
};

export const showAward = (state = [], action) => {
  if (action.type === CERTIFICATE_MODAL) return action.payload;
  return state;
};

export const creditedGamePointsReducer = (state = [], action) => {
  if (action.type === USER_GAME_POINTS) return action.payload;
  return state;
};

export const gamificationTeamLeaderBoard = (state = [], action) => {
  if (action.type === FETCH_TEAM_LEADERBOARD) return action.payload;
  return state;
};
